module.exports = __webpack_public_path__ + "static/media/healthcard1.e63d9834.jpg";